import { APIRequestBase } from '@/models/api/models-api'

/**
 * Web-LINE認証情報取得リクエストクラス
 * @class GetLineOauthRequest
 */
export class GetLineOauthRequest extends APIRequestBase {
    /**
     * @constructor
     */
    constructor(_provisionShopCode) {
        super()

        this.provisionShopCode = _provisionShopCode
    }

    /** @type {string} */
    provisionShopCode = null
}
